/* eslint-disable no-await-in-loop */
import { sleep } from "./async.js";

export const jitter = ({ max, min }: { min: number; max: number }): number => {
  if (min >= max) {
    throw new Error("Min must be less than max");
  }

  return Math.floor(Math.random() * (max - min + 1) + min);
};

export interface RetryArgs<R> {
  func: (attempt: number) => Promise<R>;
  retryCount: number;
  interval: number; // in millis
  shouldRetry?: (err: unknown) => boolean;
}

export async function retry<R>({
  func,
  interval,
  retryCount,
  shouldRetry,
}: RetryArgs<R>): Promise<R> {
  for (let i = 0; i <= retryCount; i++) {
    try {
      return await func(i + 1);
    } catch (err) {
      if (shouldRetry != null && !shouldRetry(err)) {
        throw err;
      }
      if (i < retryCount - 1) {
        await sleep(interval);
      } else {
        throw err;
      }
    }
  }

  throw new Error("Impossible to reach.");
}
